import _classCallCheck from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/thema-developers/nuovo-osix-configurator-usa/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";

var Frontali = /*#__PURE__*/function (_Vue) {
  _inherits(Frontali, _Vue);

  var _super = _createSuper(Frontali);

  function Frontali() {
    var _this;

    _classCallCheck(this, Frontali);

    _this = _super.apply(this, arguments); // tipo: string = "";

    _this.selectedSize = "";
    _this.previousSize = "";
    _this.find = "";
    _this.affogatiEnabled = false;
    _this.showSunModelNotAvailable = false;
    return _this;
  }

  _createClass(Frontali, [{
    key: "frontale",
    get: function get() {
      return this.$store.state.configurator.frontale;
    }
  }, {
    key: "calibro",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.calibro);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "naso",
    get: function get() {
      var parsed = parseInt(this.$store.state.configurator.naso);
      return isNaN(parsed) ? 0 : parsed;
    }
  }, {
    key: "items",
    get: function get() {
      return this.$store.state.configurator.frontali.items;
    }
  }, {
    key: "areThereAffogati",
    get: function get() {
      return this.items.find(function (el) {
        return el.U_THE_TECNOLOGIA == "AFF";
      });
    }
  }, {
    key: "filteredItems",
    get: function get() {
      var _this2 = this;

      var query = this.find;
      return this.items.filter(function (i) {
        var areAffogati = _this2.affogatiEnabled ? i.U_THE_TECNOLOGIA == "AFF" : i.U_THE_TECNOLOGIA != "AFF";
        var toFind = _this2.find && _this2.find != "" ? i.U_THE_MODELLO.indexOf(query) > -1 : true;
        var tipo = _this2.tipo == "V" ? i.U_TIPO_VSP == "V" : i.U_TIPO_VSP == "S";
        return i.U_THE_CUSMODEL == "C" && tipo && areAffogati && toFind;
      }).sort(function (a, b) {
        var _a$U_THE_MODELLO$matc, _b$U_THE_MODELLO$matc;

        // ordina per TYPE (TOP e NEW prima)
        if (a.TYPE === 'TOP' && b.TYPE !== 'TOP') return -1;
        if (a.TYPE !== 'TOP' && b.TYPE === 'TOP') return 1;
        if (a.TYPE === 'NEW' && b.TYPE !== 'NEW') return -1;
        if (a.TYPE !== 'NEW' && b.TYPE === 'NEW') return 1; // Se TYPE è uguale o non è né TOP né NEW, ordina in base al numero dopo "OV"

        var regex = /OV-(\d+)(C|SC)/;
        var numberA = parseInt(((_a$U_THE_MODELLO$matc = a.U_THE_MODELLO.match(regex)) === null || _a$U_THE_MODELLO$matc === void 0 ? void 0 : _a$U_THE_MODELLO$matc[1]) || "0", 10);
        var numberB = parseInt(((_b$U_THE_MODELLO$matc = b.U_THE_MODELLO.match(regex)) === null || _b$U_THE_MODELLO$matc === void 0 ? void 0 : _b$U_THE_MODELLO$matc[1]) || "0", 10);
        return numberB - numberA; // Ordina in ordine decrescente
      });
    }
  }, {
    key: "sizes",
    get: function get() {
      return this.$store.state.configurator.frontali.itemsSizes;
    }
  }, {
    key: "tipo",
    get: function get() {
      return this.$store.state.configurator.glassType;
    },
    set: function set(t) {
      var _this3 = this;

      this.$store.commit("configurator/setLensesType", t, {
        root: true
      }); // If the selected model is sun, check whether the sun version is actually available

      if (t == "S") {
        var filtered = this.items.filter(function (i) {
          return i.U_THE_CUSMODEL == "C" && i.U_TIPO_VSP == "S";
        }); // If the corresponding sun model is not found, show an error to the user and bring him back to sight models

        if (filtered.find(function (f) {
          return f.U_THE_MODELLO == _this3.frontale.U_THE_MODELLO.replaceAll("C", "SC");
        }) == undefined) {
          this.showSunModelNotAvailable = true;
          return;
        }
      }

      this.$store.commit("resetLentiVista");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaDx");
      this.$store.commit("configurator/lenti/resetCfgLenteVistaSx");
      this.$store.commit("resetRowNotes");
    }
  }, {
    key: "itemSizes",
    get: function get() {
      var front = this.$store.state.configurator.frontale;

      if (front && this.sizes.length > 0) {
        return this.sizes.filter(function (s) {
          return s.ItemCode == front.ItemCode;
        });
      }

      return [];
    }
  }, {
    key: "checkErrorsFrontali",
    get: function get() {
      return this.$store.getters["configurator/frontali/checkErrors"];
    }
  }, {
    key: "frontaliSizeError",
    get: function get() {
      return this.checkErrorsFrontali.find(function (el) {
        return el.label == "size";
      });
    }
  }, {
    key: "asianFitting",
    get: function get() {
      return this.$store.state.configurator.asianFitting;
    },
    set: function set(af) {
      this.$store.commit("configurator/setAsianFitting", af);
    }
  }, {
    key: "tintaUnita",
    get: function get() {
      return this.$store.state.tintaUnita;
    }
  }, {
    key: "finitura",
    get: function get() {
      return this.$store.state.configurator.finitura;
    }
  }, {
    key: "colore",
    get: function get() {
      return this.$store.state.configurator.colore;
    }
  }, {
    key: "coloreAste",
    get: function get() {
      return this.$store.state.configurator.coloreAste;
    }
  }, {
    key: "temples",
    get: function get() {
      var _this4 = this;

      if (this.$store.state.affogatiEnabled) {
        var height = this.getLastNumberFromString(this.frontale.ModelName);

        var _aste = this.$store.state.mappedTempleColors.get(height).filter(function (a) {
          return _this4.finitura == "N" ? a.U_THE_FINITURA == _this4.finitura : a.U_THE_FINITURA != "N";
        });

        if (this.finitura == "N") {
          this.$store.state.cachedAsteAffogatiNaturali = _aste;
        } else {
          this.$store.state.cachedAsteAffogatiLucide = _aste;
        }

        return _aste;
      }

      if (this.$store.state.cachedAsteNonAffogati.length > 0) {
        return this.$store.state.cachedAsteNonAffogati;
      }

      var aste = this.$store.state.configurator.aste.allColors.filter(function (a) {
        var _a$U_THE_MODELLO, _a$U_THE_MODELLO2;

        return !((_a$U_THE_MODELLO = a.U_THE_MODELLO) !== null && _a$U_THE_MODELLO !== void 0 && _a$U_THE_MODELLO.includes("7.5F")) && !((_a$U_THE_MODELLO2 = a.U_THE_MODELLO) !== null && _a$U_THE_MODELLO2 !== void 0 && _a$U_THE_MODELLO2.includes("12F"));
      });
      this.$store.state.cachedAsteNonAffogati = aste;
      return aste;
    }
  }, {
    key: "getLastNumberFromString",
    value: function getLastNumberFromString(inputString) {
      // Define a regular expression pattern to match numbers at the end of the string
      var pattern = /(\d{1,3}(?:[.,]\d{3})*(?:[.,]\d+)?)(?=\D*$|$)/; // Use the match method to find the number

      var match = inputString.match(pattern); // Check if a match was found

      if (match) {
        // Extract the matched number and replace commas with periods
        var matchedNumber = match[0].replace(",", "."); // Parse the number as a float

        var parsedNumber = parseFloat(matchedNumber);
        return parsedNumber;
      } // If no match was found, return NaN or handle it as needed


      return NaN;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.affogatiEnabled = this.$store.state.affogatiEnabled;
    }
  }, {
    key: "setSize",
    value: function setSize(s) {
      this.$store.commit("configurator/setSize", s);
    }
  }, {
    key: "setFrontal",
    value: function setFrontal(f) {
      var _this$frontale;

      if (((_this$frontale = this.frontale) === null || _this$frontale === void 0 ? void 0 : _this$frontale.U_THE_SOTTOLINEA) != (f === null || f === void 0 ? void 0 : f.U_THE_SOTTOLINEA)) {
        // Reset materiale
        this.$store.commit("configurator/setTemplesMaterial", "PL"); // Reset abbellitore

        this.$store.commit("configurator/setAbbellitore", null); // Reset colors

        this.$store.dispatch("configurator/frontali/setColor", "EP0001");
        this.$store.dispatch("configurator/aste/setColor", (f === null || f === void 0 ? void 0 : f.U_THE_SOTTOLINEA) == "OVBOLDUS" ? "PRO0001846" : "PL0001"); // Reset finishing to Shiny

        this.$store.commit("configurator/setFinishing", "S");
        this.$store.commit("configurator/setTemplesFinishing", "S");
      }

      this.$store.commit("configurator/setFrontal", f);
    }
  }, {
    key: "setSunLensesModel",
    value: function setSunLensesModel(l) {
      this.$store.commit("configurator/setSunLensesModel", l);
    }
  }, {
    key: "resetPreviousLenses",
    value: function resetPreviousLenses() {
      this.$store.commit("configurator/setOftLensesDxModel", this.$store.state.lenteDx);
      this.$store.commit("configurator/setOftLensesSxModel", this.$store.state.lenteSx);
    }
  }, {
    key: "calibroChanged",
    value: function calibroChanged(newV) {
      if (newV == "") {
        this.selectedSize = "";
      }
    }
  }, {
    key: "sizeChanged",
    value: function sizeChanged(newV) {
      var _this5 = this;

      var s = this.itemSizes.filter(function (s) {
        return s.id == newV;
      });

      if (s.length > 0) {
        var foundSize = this.sizes.find(function (el) {
          return el.U_THE_MODELLO == _this5.frontale.U_THE_MODELLO && el.size_eye == _this5.calibro.toFixed(2) && el.size_bridge == _this5.naso.toFixed(2);
        });
        this.previousSize = foundSize == undefined ? null : foundSize.id;
        this.setSize(s[0]);
      } else {
        this.$store.commit("configurator/setSize", {
          size_eye: "",
          size_bridge: ""
        });
      }
    }
  }, {
    key: "tipoChanged",
    value: function tipoChanged(newVal) {
      var _this6 = this;

      this.setSunLensesModel(null);
      var m = this.items.filter(function (i) {
        return i.U_THE_MODELLO.replace("SC", "").replace("C", "") == _this6.frontale.U_THE_MODELLO.replace("SC", "").replace("C", "") && i.U_TIPO_VSP == newVal;
      });

      if (m.length > 0) {
        this.setFrontal(m[0]);
      }

      if (this.calibro && this.naso) {
        var s = this.itemSizes.filter(function (is) {
          return is.ItemCode == m[0].ItemCode && parseInt(is.size_eye) == _this6.calibro && parseInt(is.size_bridge) == _this6.naso;
        });

        if (s.length > 0) {
          this.setSize(s[0]);
        }
      }
    }
  }]);

  return Frontali;
}(Vue);

__decorate([Watch("calibro")], Frontali.prototype, "calibroChanged", null);

__decorate([Watch("selectedSize")], Frontali.prototype, "sizeChanged", null);

__decorate([Watch("tipo")], Frontali.prototype, "tipoChanged", null);

Frontali = __decorate([Component({})], Frontali);
export default Frontali;